import React from 'react'
import PropTypes from 'prop-types';

function SignalMeter (props) {
  var containerStyle = {
    width: 50,
    height: 20,
    padding: '5px',
    marginLeft: '10px',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    borderRadius: 2,
    // background: '#eeeeee',
  };

  function barStyle(bar) {
    return {
      borderRadius: 2,
      width: '20%',
      height: `${25 * bar}%`,
      background: props.strength >= 25 * (bar - 1) + 10 ? 'red' : 'lightgrey',
    }
  }

  return (
    <div style={containerStyle}>
      <div style={barStyle(1)} />
      <div style={barStyle(2)} />
      <div style={barStyle(3)} />
      <div style={barStyle(4)} />
    </div>
  )
}

SignalMeter.propTypes = {
  strength: PropTypes.number.isRequired,
}

export default SignalMeter